import {ActionDto} from '../dto/action.dto';
import {Action} from '../model/action';

export function convertActionDtoToModel(dto: ActionDto): Action {
  return {
    ...dto,
    id: dto._id,
  };
}
